export const selectRadioOption = (options: any[], id: string) =>
  options.map(opt => ({
    ...opt,
    selected: opt.id === id,
  }));

// export const toggleCheckboxOption = (options: any[], id: string) =>
// options.map(opt => ({
//   ...opt,
//   selected: opt.id === id ? !opt.selected : opt.selected,
// }));

export const toggleCheckboxOption = (options: any[], id: string) =>
  options.map(opt => (opt.id === id ? {...opt, selected: !opt.selected} : opt));
